import { useContextSelector } from "use-context-selector";
import SkyLayout from "./SkyLayout";
import AuthContext from "../../context/AuthContext";

const AccountSky = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  return (
    <SkyLayout>
      <div class="mian-wrap">
        <div class="path-wrap">
          <p class="account-id">
            <span>{user?.user?.username}</span>
            <span class="time-zone">GMT+5:30</span>
          </p>
        </div>

        <ul class="menu-list">
          <li class="">
            <a href="/exchange/profile">My Profile</a>
          </li>

          <li class="">
            <a href="/exchange/balance-overview">Balance Overview</a>
          </li>
          <li class="">
            <a href="/exchange/my-bets">My Bets</a>
          </li>
          <li class="">
            <a href="/exchange/my-bets">Bets History</a>
          </li>

          <li class="">
            <a href="/exchange/profit-loss">Profit &amp; Loss</a>
          </li>

          <li class="">
            <a href="/exchange/activity-log">Activity Log</a>
          </li>
        </ul>
      </div>
    </SkyLayout>
  );
};

export default AccountSky;
